@file:OptIn(InternalResourceApi::class)

package finglish.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/finglish.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_054_443_875)
internal val Res.font.montserrat_bold: FontResource by lazy {
      FontResource("font:montserrat_bold", setOf(
        ResourceItem(setOf(), "${MD}font/montserrat_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_006_533_791)
internal val Res.font.montserrat_regular: FontResource by lazy {
      FontResource("font:montserrat_regular", setOf(
        ResourceItem(setOf(), "${MD}font/montserrat_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_767_465_897)
internal val Res.font.vazirmatn_bold: FontResource by lazy {
      FontResource("font:vazirmatn_bold", setOf(
        ResourceItem(setOf(), "${MD}font/vazirmatn_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_181_805_955)
internal val Res.font.vazirmatn_regular: FontResource by lazy {
      FontResource("font:vazirmatn_regular", setOf(
        ResourceItem(setOf(), "${MD}font/vazirmatn_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("montserrat_bold", Res.font.montserrat_bold)
  map.put("montserrat_regular", Res.font.montserrat_regular)
  map.put("vazirmatn_bold", Res.font.vazirmatn_bold)
  map.put("vazirmatn_regular", Res.font.vazirmatn_regular)
}
